(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dogfirst-mobile-optimizer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const marker = document.querySelector('[data-dfc-mobile-optimizer]');
    if (!marker || marker.dataset.ready === 'true') return;

    const root = document.documentElement;
    const primaryForm = document.querySelector('.dfc-pdp-hero .dfc-buy');
    const primaryButton = primaryForm?.querySelector('[data-dfc-buy-button]');
    const finalButton = document.querySelector('.dfc-peach [data-dfc-buy-button]');
    const priceSource = document.querySelector('.dfc-pdp-hero [data-dfc-price]');

    if (!primaryForm || !primaryButton) return;

    marker.dataset.ready = 'true';
    root.classList.add('dfc-pdp-v2');

    const bar = document.createElement('div');
    bar.className = 'dfc-sticky-buy';
    bar.setAttribute('aria-hidden', 'true');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'dfc-sticky-buy__button';
    button.tabIndex = -1;

    const label = document.createElement('span');
    label.textContent = primaryButton.textContent.trim();
    button.append(label);

    if (priceSource) {
      const separator = document.createTextNode(' · ');
      const price = document.createElement('span');
      price.className = 'dfc-sticky-buy__price';
      price.textContent = priceSource.textContent.trim();
      button.append(separator, price);

      new MutationObserver(() => {
        price.textContent = priceSource.textContent.trim();
      }).observe(priceSource, { childList: true, characterData: true, subtree: true });
    }

    bar.append(button);
    document.body.append(bar);

    button.addEventListener('click', () => {
      primaryForm.requestSubmit(primaryButton);
    });

    let ticking = false;
    const update = () => {
      ticking = false;
      const primaryRect = primaryButton.getBoundingClientRect();
      const finalRect = finalButton?.getBoundingClientRect();
      const hasPassedPrimary = primaryRect.bottom < 0;
      const finalIsVisible = finalRect
        ? finalRect.top < window.innerHeight && finalRect.bottom > 0
        : false;
      const shouldShow = window.matchMedia('(max-width: 749px)').matches
        && hasPassedPrimary
        && !finalIsVisible;

      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', String(!shouldShow));
      button.tabIndex = shouldShow ? 0 : -1;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(marker)) return;
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      bar.remove();
      root.classList.remove('dfc-pdp-v2');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
